(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-collage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__lookbookCollageInit) return;
    window.__lookbookCollageInit = true;

    const open = (section, index) => {
      const dialog = section.querySelector('.lookbook-collage__dialog');
      const triggers = [...section.querySelectorAll('.lookbook-collage__open')];
      if (!dialog || !triggers.length) return;
      const show = (i) => {
        const t = triggers[(i + triggers.length) % triggers.length];
        dialog.dataset.index = triggers.indexOf(t);
        const img = dialog.querySelector('.lookbook-collage__dialog-img');
        const thumb = t.querySelector('img');
        img.src = (thumb && thumb.currentSrc) || t.dataset.full;
        const full = new Image();
        full.onload = () => { if (dialog.dataset.index == triggers.indexOf(t)) img.src = full.src; };
        full.src = t.dataset.full;
        img.alt = t.dataset.alt || '';
        dialog.querySelector('.lookbook-collage__dialog-caption').textContent = t.dataset.caption || '';
      };
      show(index);
      dialog._show = show;
      if (!dialog.open) dialog.showModal();
    };

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.lookbook-collage__open');
      if (trigger) {
        const section = trigger.closest('.lookbook-collage');
        const triggers = [...section.querySelectorAll('.lookbook-collage__open')];
        open(section, triggers.indexOf(trigger));
        return;
      }
      const dialog = e.target.closest('.lookbook-collage__dialog');
      if (!dialog) return;
      const i = Number(dialog.dataset.index || 0);
      if (e.target.closest('.lookbook-collage__nav--prev')) dialog._show(i - 1);
      else if (e.target.closest('.lookbook-collage__nav--next')) dialog._show(i + 1);
      else if (e.target.closest('.lookbook-collage__close') || e.target === dialog) dialog.close();
    });

    document.addEventListener('keydown', (e) => {
      const dialog = document.querySelector('.lookbook-collage__dialog[open]');
      if (!dialog || !dialog._show) return;
      const i = Number(dialog.dataset.index || 0);
      if (e.key === 'ArrowLeft') dialog._show(i - 1);
      if (e.key === 'ArrowRight') dialog._show(i + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
